<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
        <TableView
          :headers="headers"
          :items="allData"
          :options.sync="options"
          :loading="loading"
          :totalData="totalData"
          :refresh-table="getData"
          :bodyFilter="true"
          :customTopActions="true"
          item-key="id"
          table-height="70vh"
        >     
          <template v-slot:top>
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px;">
              <div>
                <p class="font-weight-black mb-1">List Merchant Onboarding MID Kosong</p>
                <v-chip
                  v-if="selectedData.length > 0"
                  small
                  class="mt-1"
                  :close="true"
                  @click:close="clearSelected"
                >
                  {{ `${selectedData.length} data(s) selected` }}
                </v-chip>
              </div>

              <div style="display: flex; gap: 10px">
                <v-btn
                  color="primary"
                  class="mb-2 rounded-pill elevation-0"
                  @click="fillMid"
                  :loading="loadingFill"
                >
                  Fill MID
                </v-btn>
                <v-btn
                  color="error"
                  class="mb-2 rounded-pill elevation-0"
                  @click="getData"
                  :loading="loading"
                >
                  Get MID Kosong
                </v-btn>
            
              </div>
            </div>
          </template>
           <template v-slot:body-prepend>
            <StockMidFillFilter
              :search="search"
              :dataList="allData"
              :selectedData="selectedData"
              :selectAllData="selectAllData"
              v-on:getDataParent="getData"
              v-on:selectedDataParent="changeSelectedData"
              v-on:selectAllDataParent="changeSelectAllData"
            />
          </template>
          <template v-slot:custom="{ item }">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectedData"
              :value="item.id"
            />
          </template>
           <template v-slot:action="{ item }">
           <v-icon small class="mr-2" @click="viewItem(item.id)"> mdi-eye </v-icon>
          </template>
      </TableView>

    <v-dialog v-model="dialog" max-width="500px">
      <table-detail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import { date, showAlert } from '../../lib/helpers';
import { headers, search } from '../mid/stock-mid/attributes';

export default {
  components: {
    StockMidFillFilter: () => import('../table/StockMidFillFilter.vue'),
    TableDetail: () => import('../table/StockMidFillDetail.vue'),
    TableView: () => import("../@drontVue/components/Table/TableView.vue"),
  },
  name: 'StockMidList',
  data: () => ({
    isFirstLoad: false,
    options: {},
    view: false,
    dialog: false,
    headers,
    search,
    defaultItem: {
      id: '',
      source_onboarding: '',
      merchant_name: '',
      reference_number: '',
      kode_wilayah: '',
      tipe_merchant: '',
      created_at: '',
    },
    selectedRow: '',
    selectedData: [],
    selectAllData: false,
    maxSelected: 100,
    loadingFill: false,
  }),
  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('stockMid/fill/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },
  computed: {
    allData() {
      return this.$store.state.stockMid.fill.allData;
    },
    totalData() {
      return this.$store.state.stockMid.fill.totalData;
    },
    totalPage() {
      return this.$store.state.stockMid.fill.totalPage;
    },
    editedItem() {
      return this.$store.state.stockMid.fill.item;
    },
    loading() {
      return this.$store.state.stockMid.fill.loading;
    },
    flashError: {
      get() {
        return this.$store.state.stockMid.fill.flashError;
      },
      set() {
        this.$store.commit('stockMid/fill/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.stockMid.fill.flashErrorMessage;
    },
  },
  methods: {
    async viewItem(itemId) {
      await this.$store
        .dispatch('stockMid/fill/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          this.dialog = true;
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        const defaultData = { ...this.defaultItem };
        this.$store.commit('stockMid/fill/setItem', {
          payload: { data: defaultData },
        });
      });
    },
    changeSelectedData(newSelected) {
      this.selectedData = newSelected;
    },
    changeSelectAllData(newSelectedAll) {
      this.selectAllData = newSelectedAll;
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length == 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    getData() {
      this.$store.commit('stockMid/fill/setFlashErrorMessage', '');
      const { page, itemsPerPage } = this.options;
      this.$store
        .dispatch('stockMid/fill/getData', {
          date,
          page,
          itemsPerPage,
    
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
    },
    fillMid() {
      if (this.selectedData.length <= 0) {
        showAlert(
          this.$store,
          'Tidak ada merchant yang dipilih !',
          'mdi-alert',
          'red'
        );
      } else {
        this.loadingFill = true;
        this.$store
          .dispatch('stockMid/fill/bulkApprove', {
            date,
            id: this.selectedData,
          })
          .then((res) => {
            if (res) {
              this.clearSelected();
              this.getData();
              showAlert(
                this.$store,
                `Proses Pengisian MID Merchant Berhasil ! data sukses : ${res.succesCount}, data gagal : ${res.failedCount}`,
                'mdi-check-circle',
                'green'
              );
            } else {
              showAlert(
                this.$store,
                'Proses Pengisian MID Gagal !',
                'mdi-alert',
                'red'
              );
            }
          })
          .finally(() => {
            this.loadingFill = false;
          });
      }
    },
    clearSearch() {
      this.search.merchantName = '';
      this.search.referenceNumber = '';
      this.search.areaCode = '';
      this.search.createdDate = [];

      this.$nextTick(() => {
        this.$store.commit('stockMid/fill/clearData');
        this.getData();
      });
    },
  },
};
</script>
